<div class="comunicado-list">
  <div 
    *ngFor="let item of comunicados; let i = index" 
    class="comunicado-item" 
    [class.unread]="!item.lido"
    [class.selected]="item.selected"
    [class.loading]="isItemLoading(item.id)"
    (click)="exibir(item.id)">
    
    <!-- Comunicado Header -->
    <div class="comunicado-header">
      <div class="comunicado-sender">
        <div class="sender-avatar">
          <i class="fas fa-user"></i>
        </div>
        <div class="sender-info">
          <div class="sender-name">{{item.remetente.nome}}</div>
          <!-- Email do remetente não será incluído nesta versão -->
          <!-- <div class="sender-email" *ngIf="item.remetente.email">{{item.remetente.email}}</div> -->
        </div>
      </div>
      
      <div class="comunicado-meta" [title]="formatDate(item.enviado) | date: 'dd/MM/yy HH:mm'">
        <div class="comunicado-date">{{ formatDate(item.enviado) | date: formatoDataLista : '' : localeAtual }}</div>
        <div class="comunicado-time">{{ formatDate(item.enviado) | date: formatoHoraLista : '' : localeAtual }}</div>
      </div>
    </div>
    
    <!-- Comunicado Subject -->
    <div class="comunicado-subject">
      <span class="subject-text">{{item.assunto}}</span>
      <div class="comunicado-badges">
        <span *ngIf="!item.lido" class="badge unread-badge" translate>{{ 'comunicado.lista.novo' }}</span>
        <span *ngIf="item.anexos.length > 0" class="badge attachment-badge">
          <i class="fas fa-paperclip"></i>
          {{item.anexos.length}}
        </span>
        <span *ngIf="item.tipo_envio == TipoEnvio.PORTAL" class="badge type-badge" [ngClass]="TipoEnvioClasses[TipoEnvio.PORTAL]">
          <i [ngClass]="TipoEnvioIcons[TipoEnvio.PORTAL]"></i>
          <span translate>{{ TipoEnvioLabels[TipoEnvio.PORTAL] }}</span>
        </span>
        <span *ngIf="item.tipo_envio == TipoEnvio.EMAIL" class="badge type-badge" [ngClass]="TipoEnvioClasses[TipoEnvio.EMAIL]">
          <i [ngClass]="TipoEnvioIcons[TipoEnvio.EMAIL]"></i>
          <span translate>{{ TipoEnvioLabels[TipoEnvio.EMAIL] }}</span>
        </span>
        <span *ngIf="item.tipo_envio == TipoEnvio.AMBOS" class="badge type-badge" [ngClass]="TipoEnvioClasses[TipoEnvio.AMBOS]">
          <i [ngClass]="TipoEnvioIcons[TipoEnvio.AMBOS]"></i>
          <span translate>{{ TipoEnvioLabels[TipoEnvio.AMBOS] }}</span>
        </span>
      </div>
    </div>
    
    <!-- Comunicado Preview -->
    <div class="comunicado-preview">
      <div class="preview-text">
        {{item.conteudo || 'Sem conteúdo de prévia disponível...'}}
      </div>
    </div>
    
    <!-- Loading Indicator -->
    <div *ngIf="isItemLoading(item.id)" class="item-loading">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <span class="loading-text" translate>{{ 'comunicado.lista.carregandoItem' }}</span>
    </div>
    
    <!-- Comunicado Actions -->
    <!-- TODO: Implementar funcionalidade de marcar como lido futuramente -->
    <!-- <div class="comunicado-actions">
      <button class="action-btn" (click)="exibir(item.id); $event.stopPropagation()" [title]="'comunicado.lista.abrirComunicado'">
        <i class="fas fa-eye"></i>
      </button>
      <button *ngIf="!item.lido" class="action-btn" (click)="markAsRead(item); $event.stopPropagation()" [title]="'comunicado.lista.marcarComoLido'">
        <i class="fas fa-check"></i>
      </button>
    </div> -->
  </div>
  
  <!-- Empty State -->
  <div *ngIf="comunicados.length === 0" class="empty-state">
    <div class="empty-icon">
      <i class="fas fa-inbox"></i>
    </div>
    <div class="empty-title" translate>{{ 'comunicado.lista.nenhumComunicadoEncontrado' }}</div>
    <div class="empty-subtitle" translate>{{ 'comunicado.lista.naoHaComunicados' }}</div>
  </div>
</div>